const route = [
    {//检查作业
        //sid：学科id 91小学  92初中
        //taskid：作业ID
        //classid：班级ID
        //type：作业类型
        path: '/english/taskdetial/:sid/:taskid/:type/:classid',
        component: function (resolve) {
            require(['VIEWS/english/inspect/taskdetial.vue'], resolve);
        }
    },
    {//检查作业——跟读作业预览
        //sid：学科id 91小学  92初中
        //message_id：作业ID
        //task_type：作业类型
        path: '/english/read_preview/:sid/:message_id/:task_type',
        component: function (resolve) {
            require(['VIEWS/english/inspect/read_preview.vue'], resolve);
        }
    },
    {//检查作业——课外跟读个人详情
        //sid：学科id 91小学  92初中
        //message_id：作业ID
        //user_id：个人ID
        //task_type：作业类型
        path: '/english/nom_check/:sid/:message_id/:task_type/:user_id',
        component: function (resolve) {
            require(['VIEWS/english/inspect/nom_check.vue'], resolve);
        }
    },
    {//检查作业——课外跟读个人详情
        //sid：学科id 91小学  92初中
        //message_id：作业ID
        //user_id：个人ID
        //task_type：作业类型
        path: '/english/nom_repeat/:sid/:message_id/:task_type/:user_id',
        component: function (resolve) {
            require(['VIEWS/english/inspect/nom_repeat.vue'], resolve);
        }
    },
    {//检查作业——做题作业预览、个人做题作业详情
        //sid：学科id 91小学  92初中
        //message_id：作业ID
        //task_type：作业类型
        path: '/english/preview/:sid/:message_id/:task_type',
        component: function (resolve) {
            require(['VIEWS/english/inspect/preview.vue'], resolve);
        }
    },
    {//检查作业——做题错误率单题详情
        //sid：学科id 91小学  92初中
        //message_id：作业ID
        //qid:题目Id
        path: '/english/single_preview/:sid/:message_id/:qid',
        component: function (resolve) {
            require(['VIEWS/english/inspect/single_preview.vue'], resolve);
        }
    },
];
export default route
